import { Injectable, inject, signal } from '@angular/core';
import { QueryBuilder } from '@softline/core';
import { ClaimReportSalesOrderRepository } from '../repositories/claim-report-sales-order.repository';
import {
  ClaimReportSalesOrder,
  ClaimReportSalesOrderQueryRow,
  ClaimReportSalesOrderResponseRow,
} from '../types/claim-report-document-query';

@Injectable()
export class ClaimReportSalesOrderService {
  private readonly repository = inject(ClaimReportSalesOrderRepository);

  readonly salesOrders = signal<ClaimReportSalesOrder[]>([]);
  readonly isLoading = signal(false);
  readonly error = signal<unknown>(null);

  async load(customerNumber: number): Promise<void> {
    this.isLoading.set(true);
    this.error.set(null);
    try {
      const query = new QueryBuilder<ClaimReportSalesOrderQueryRow>()
        .column('sales_order.id')
        .column('sales_order.document_date')
        .sort('sales_order.document_date', 'DESC')
        .filter({ type: 'stringEquals', name: 'sales_order.sale_department', value: 'V' })
        .filter({
          type: 'numberEquals',
          name: 'invoice_customer.number',
          value: customerNumber,
        })
        .start(0)
        .end(100)
        .build();
      const result = await this.repository.load({ query });
      const rows = (result?.data ?? []) as unknown as ClaimReportSalesOrderResponseRow[];
      this.salesOrders.set(
        rows.map((row) => ({
          id: row.sales_order.id,
          documentDate: row.sales_order.document_date,
        }))
      );
    } catch (e) {
      this.error.set(e);
      throw e;
    } finally {
      this.isLoading.set(false);
    }
  }
}
